import { Component, Output, EventEmitter, Input } from '@angular/core';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';
import { QRToggle } from 'src/app/models/qr-toggle.model';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent  {
  @Input() notifications:{notificationId:number, quantity: number | null, quatityEditable: boolean | null, agent:boolean, secretariate:boolean, title:string, type:number, 
    visibleCheckAdministration:boolean, visibleCheckAgent:boolean, visibleCheckBroker:boolean, visibleCheckManager:boolean, visibleCheckNotification:boolean, visibleCheckSecretariate:boolean,
  active:boolean, administration:boolean, broker:boolean, description:string, id:number, manager:boolean}[] = [];
  @Output() onAction: EventEmitter<any> = new EventEmitter<any>();
  @Output() openDialog: EventEmitter<any> = new EventEmitter<any>();

  toggleRole: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: [],
    optionSelected: 1,
  };

  buttonPropertiesDays: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.SETTINGS,
    iconOnly: true,
  };

  buttonSave: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Guardar',
    icon: Constants.ICONS.SAVE,
  };

  onSave() {
    this.onAction.emit(this.notifications);
  }
}
